// before 20-5-2026


// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import ReactDOM from 'react-dom';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Box,
//   Typography,
//   Avatar,
//   Chip,
//   Button,
//   TextField,
//   Paper,
//   Alert,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Tooltip,
//   TablePagination,
//   TableSortLabel,
//   InputAdornment,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Grid,
//   Divider,
//   Card,
//   CardContent,
//   Badge,
//   Fade,
//   Zoom,
//   Grow,
//   Collapse,
//   LinearProgress,
//   Stack,
//   CardHeader,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemAvatar,
//   AvatarGroup,
//   alpha,
//   Modal,
// } from '@mui/material';
// import { styled, useTheme } from '@mui/material/styles';
// import { useDispatch, useSelector } from 'react-redux';
// import CloseIcon from '@mui/icons-material/Close';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import SearchIcon from '@mui/icons-material/Search';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import ClearIcon from '@mui/icons-material/Clear';
// import DownloadIcon from '@mui/icons-material/Download';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import TableChartIcon from '@mui/icons-material/TableChart';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import ScheduleIcon from '@mui/icons-material/Schedule';
// import PersonIcon from '@mui/icons-material/Person';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import CommentIcon from '@mui/icons-material/Comment';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import TrendingDownIcon from '@mui/icons-material/TrendingDown';
// import TimelineIcon from '@mui/icons-material/Timeline';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import PieChartIcon from '@mui/icons-material/PieChart';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
// import moment from 'moment';
// import XLSX from '../utils/excelUtils';
// import { Notify } from '../Utility/Notify';
// import { Get_AllComments_For_Sheet_By_User_Action } from '../Redux/Actions/MeetingCommentsAction';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Styled Components
// const StyledDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiDialog-paper': {
//     borderRadius: 24,
//     minWidth: '95vw',
//     maxWidth: '1600px',
//     height: '95vh',
//     maxHeight: '95vh',
//     display: 'flex',
//     flexDirection: 'column',
//     background:
//       theme.palette.mode === 'dark'
//         ? 'linear-gradient(145deg, #1a1a1a 0%, #2d2d2d 100%)'
//         : 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
//     boxShadow:
//       theme.palette.mode === 'dark'
//         ? '0 20px 60px rgba(0,0,0,0.5)'
//         : '0 20px 60px rgba(0,0,0,0.15)',
//     overflow: 'hidden',
//     // إزالة z-index من هنا
//   },
// }));

// const HeaderGradient = styled(Box)(({ theme }) => ({
//   background:
//     theme.palette.mode === 'dark'
//       ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)'
//       : 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
//   padding: theme.spacing(2.5),
//   color: 'white',
//   borderBottom: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.2)'}`,
//   position: 'relative',
//   overflow: 'hidden',
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     right: 0,
//     width: '300px',
//     height: '100%',
//     background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1))',
//     transform: 'skewX(-20deg) translateX(100px)',
//   },
// }));

// const StatsCard = styled(Card)(({ theme }) => ({
//   background:
//     theme.palette.mode === 'dark'
//       ? 'linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)'
//       : 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
//   borderRadius: 16,
//   border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-4px)',
//     boxShadow:
//       theme.palette.mode === 'dark'
//         ? '0 12px 24px rgba(0,0,0,0.4)'
//         : '0 12px 24px rgba(37, 99, 235, 0.15)',
//     borderColor: theme.palette.mode === 'dark' ? '#2563eb' : '#2563eb',
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 500,
//   borderBottom: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
//   '&.MuiTableCell-head': {
//     backgroundColor:
//       theme.palette.mode === 'dark' ? 'rgba(37, 99, 235, 0.15)' : 'rgba(37, 99, 235, 0.08)',
//     fontWeight: 700,
//     color: theme.palette.mode === 'dark' ? '#fff' : '#1e293b',
//     borderBottom: `2px solid ${theme.palette.mode === 'dark' ? '#2563eb' : '#2563eb'}`,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   transition: 'all 0.2s ease',
//   '&:hover': {
//     backgroundColor:
//       theme.palette.mode === 'dark' ? 'rgba(37, 99, 235, 0.1)' : 'rgba(37, 99, 235, 0.05)',
//     transform: 'translateY(-1px)',
//     boxShadow:
//       theme.palette.mode === 'dark'
//         ? '0 4px 12px rgba(0,0,0,0.3)'
//         : '0 4px 12px rgba(37, 99, 235, 0.1)',
//   },
// }));

// const FilterPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   marginBottom: theme.spacing(3),
//   backgroundColor:
//     theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.8)' : 'rgba(241, 245, 249, 0.8)',
//   backdropFilter: 'blur(10px)',
//   borderRadius: 20,
//   border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     backgroundColor:
//       theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.9)' : 'rgba(241, 245, 249, 0.9)',
//     borderColor:
//       theme.palette.mode === 'dark' ? 'rgba(37, 99, 235, 0.3)' : 'rgba(37, 99, 235, 0.3)',
//   },
// }));

// // Component for empty state
// const EmptyState = ({ mode, onRefresh }) => (
//   <Fade in timeout={500}>
//     <Box
//       sx={{
//         textAlign: 'center',
//         py: 8,
//         px: 2,
//         backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
//         borderRadius: 4,
//       }}
//     >
//       <Zoom in timeout={600}>
//         <Box sx={{ position: 'relative', display: 'inline-block' }}>
//           <CommentIcon
//             sx={{
//               fontSize: 100,
//               color: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               mb: 2,
//             }}
//           />
//           <Box
//             sx={{
//               position: 'absolute',
//               top: -10,
//               right: -10,
//               width: 30,
//               height: 30,
//               borderRadius: '50%',
//               backgroundColor: '#2563eb',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               animation: 'pulse 2s infinite',
//               '@keyframes pulse': {
//                 '0%': { transform: 'scale(1)', opacity: 1 },
//                 '50%': { transform: 'scale(1.2)', opacity: 0.8 },
//                 '100%': { transform: 'scale(1)', opacity: 1 },
//               },
//             }}
//           >
//             <span style={{ color: 'white', fontSize: 16 }}>0</span>
//           </Box>
//         </Box>
//       </Zoom>
//       <Typography variant="h4" color="text.secondary" gutterBottom fontWeight={300}>
//         No Comments Found
//       </Typography>
//       <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 400, mx: 'auto' }}>
//         No comments match your filters. Try adjusting your search criteria.
//       </Typography>
//       <Button
//         variant="contained"
//         startIcon={<RefreshIcon />}
//         onClick={onRefresh}
//         sx={{
//           borderRadius: 8,
//           px: 4,
//           py: 1.5,
//           background: 'linear-gradient(45deg, #2563eb 30%, #7c3aed 90%)',
//           '&:hover': {
//             transform: 'translateY(-2px)',
//             boxShadow: '0 6px 16px rgba(37, 99, 235, .4)',
//           },
//         }}
//       >
//         Refresh
//       </Button>
//     </Box>
//   </Fade>
// );

// // Modal Component للـ Details
// const DetailsModal = ({ open, onClose, comment, mode, getStageColor, getStageIcon }) => {
//   if (!open) return null;

//   return ReactDOM.createPortal(
//     <Fade in={open}>
//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           zIndex: 999999,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}
//       >
//         {/* Backdrop */}
//         <Box
//           sx={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.7)',
//             backdropFilter: 'blur(8px)',
//             zIndex: 999998,
//           }}
//           onClick={onClose}
//         />

//         {/* Modal Content */}
//         <Paper
//           sx={{
//             borderRadius: 4,
//             background:
//               mode === 'dark'
//                 ? 'linear-gradient(145deg, #1e293b 0%, #0f172a 100%)'
//                 : 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
//             border: `1px solid ${mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(37, 99, 235, 0.1)'}`,
//             width: '900px',
//             maxWidth: '90vw',
//             maxHeight: '90vh',
//             overflow: 'auto',
//             position: 'relative',
//             zIndex: 999999,
//             boxShadow:
//               mode === 'dark'
//                 ? '0 50px 100px -20px rgba(0,0,0,0.8), 0 30px 60px -30px rgba(37,99,235,0.5)'
//                 : '0 50px 100px -20px rgba(37,99,235,0.5), 0 30px 60px -30px rgba(37,99,235,0.3)',
//           }}
//         >
//           <Box sx={{ p: 3 }}>
//             {/* Header */}
//             <Box
//               sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                 <Avatar sx={{ bgcolor: '#2563eb', width: 40, height: 40 }}>
//                   <VisibilityIcon />
//                 </Avatar>
//                 <Typography variant="h6" fontWeight={600} sx={{ color: '#2563eb' }}>
//                   Comment Details
//                 </Typography>
//               </Box>
//               <IconButton onClick={onClose} size="small" sx={{ color: '#2563eb' }}>
//                 <CloseIcon />
//               </IconButton>
//             </Box>

//             {/* Content */}
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//               {/* Lead Info Card */}
//               <StatsCard>
//                 <CardContent>
//                   <Typography variant="subtitle2" sx={{ color: '#2563eb', fontWeight: 600, mb: 2 }}>
//                     👤 Lead Information
//                   </Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
//                     <Avatar sx={{ width: 70, height: 70, bgcolor: '#2563eb', fontSize: 24 }}>
//                       {comment.lead?.name?.charAt(0) || '?'}
//                     </Avatar>
//                     <Box>
//                       <Typography
//                         variant="h5"
//                         fontWeight={700}
//                         sx={{ color: mode === 'dark' ? 'white' : '#1e293b', mb: 1 }}
//                       >
//                         {comment.lead?.name || 'N/A'}
//                       </Typography>
//                       <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
//                         {comment.lead?.phone && (
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                             <PhoneIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                             <Typography variant="body2">{comment.lead.phone}</Typography>
//                           </Box>
//                         )}
//                         {comment.lead?.email && (
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                             <EmailIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                             <Typography variant="body2">{comment.lead.email}</Typography>
//                           </Box>
//                         )}
//                       </Box>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </StatsCard>

//               {/* Comment Details Card */}
//               <StatsCard>
//                 <CardContent>
//                   <Typography variant="subtitle2" sx={{ color: '#2563eb', fontWeight: 600, mb: 2 }}>
//                     💬 Comment Details
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                       <Typography variant="caption" color="textSecondary" gutterBottom>
//                         Stage
//                       </Typography>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <Chip
//                           icon={getStageIcon(comment.stage?.name)}
//                           label={comment.stage?.name || 'N/A'}
//                           size="small"
//                           sx={{
//                             backgroundColor: getStageColor(comment.stage?.name),
//                             color: 'white',
//                             fontWeight: 600,
//                             '& .MuiChip-icon': { color: 'white' },
//                           }}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="caption" color="textSecondary" gutterBottom>
//                         Developer
//                       </Typography>
//                       <Typography variant="body2" fontWeight={600}>
//                         {comment.salesdeveloperName || 'N/A'}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="caption" color="textSecondary" gutterBottom>
//                         Created At
//                       </Typography>
//                       <Typography variant="body2" fontWeight={600}>
//                         {comment.createdAt
//                           ? moment(comment.createdAt).format('DD/MM/YYYY hh:mm A')
//                           : 'N/A'}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                       <Typography variant="caption" color="textSecondary" gutterBottom>
//                         Stage Date
//                       </Typography>
//                       <Typography variant="body2" fontWeight={600}>
//                         {comment.stageDate
//                           ? moment(comment.stageDate).format('DD/MM/YYYY hh:mm A')
//                           : 'N/A'}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Typography variant="caption" color="textSecondary" gutterBottom>
//                         Comment
//                       </Typography>
//                       <Paper
//                         variant="outlined"
//                         sx={{
//                           p: 2,
//                           mt: 0.5,
//                           bgcolor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(37, 99, 235, 0.02)',
//                           borderRadius: 2,
//                           borderColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(37, 99, 235, 0.1)',
//                         }}
//                       >
//                         <Typography variant="body1">{comment.comment || 'N/A'}</Typography>
//                       </Paper>
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </StatsCard>

//               {/* Replies Card */}
//               {comment.replies && comment.replies.length > 0 && (
//                 <StatsCard>
//                   <CardContent>
//                     <Typography
//                       variant="subtitle2"
//                       sx={{ color: '#2563eb', fontWeight: 600, mb: 2 }}
//                     >
//                       💬 Replies ({comment.replies.length})
//                     </Typography>
//                     <List>
//                       {comment.replies.map((reply, idx) => (
//                         <React.Fragment key={idx}>
//                           <ListItem alignItems="flex-start" sx={{ px: 0 }}>
//                             <ListItemAvatar>
//                               <Avatar sx={{ width: 32, height: 32, bgcolor: '#7c3aed' }}>
//                                 {reply.user?.name?.charAt(0) || '?'}
//                               </Avatar>
//                             </ListItemAvatar>
//                             <ListItemText
//                               primary={
//                                 <Box
//                                   sx={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: 1,
//                                     flexWrap: 'wrap',
//                                   }}
//                                 >
//                                   <Typography variant="subtitle2" fontWeight={600}>
//                                     {reply.user?.name || 'Unknown'}
//                                   </Typography>
//                                   <Typography variant="caption" color="textSecondary">
//                                     {reply.date
//                                       ? moment(reply.date).format('DD/MM/YYYY hh:mm A')
//                                       : ''}
//                                   </Typography>
//                                 </Box>
//                               }
//                               secondary={
//                                 <Typography
//                                   variant="body2"
//                                   sx={{
//                                     mt: 0.5,
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                                   }}
//                                 >
//                                   {reply.text}
//                                 </Typography>
//                               }
//                             />
//                           </ListItem>
//                           {idx < comment.replies.length - 1 && <Divider sx={{ my: 1 }} />}
//                         </React.Fragment>
//                       ))}
//                     </List>
//                   </CardContent>
//                 </StatsCard>
//               )}
//             </Box>

//             {/* Footer */}
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//               <Button
//                 onClick={onClose}
//                 variant="contained"
//                 sx={{
//                   borderRadius: 8,
//                   px: 4,
//                   background: 'linear-gradient(45deg, #2563eb 30%, #7c3aed 90%)',
//                   '&:hover': {
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 6px 16px rgba(37, 99, 235, .4)',
//                   },
//                 }}
//               >
//                 Close
//               </Button>
//             </Box>
//           </Box>
//         </Paper>
//       </Box>
//     </Fade>,
//     document.body,
//   );
// };

// export const PrivateSheetForUser = ({ open, onClose, userlogin }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   // States
//   const [comments, setComments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedComment, setSelectedComment] = useState(null);
//   const [detailsOpen, setDetailsOpen] = useState(false);
//   const [statsExpanded, setStatsExpanded] = useState(false);

//   // Stages states
//   const [allStages, setAllStages] = useState([]);
//   const [stagesLoading, setStagesLoading] = useState(false);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [totalCount, setTotalCount] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [hasNextPage, setHasNextPage] = useState(false);
//   const [hasPrevPage, setHasPrevPage] = useState(false);

//   // تعريف الفلاتر الافتراضية
//   const defaultFilters = {
//     stage: 'all',
//     searchTerm: '',
//     createdFrom: '',
//     createdTo: '',
//     stageDateFrom: '',
//     stageDateTo: '',
//     sortBy: 'createdAt',
//     sortOrder: 'desc',
//   };

//   // Filter states
//   const [filters, setFilters] = useState({ ...defaultFilters });
//   const [tempFilters, setTempFilters] = useState({ ...defaultFilters });

//   const [uniqueStages, setUniqueStages] = useState([]);
//   const [filterExpanded, setFilterExpanded] = useState(true);

//   // Get comments from Redux
//   const resgetallcoments = useSelector((state) => state.AllMeetingComments?.MeetingComments);

//   // Get stages from Redux
//   const All_stages = useSelector((state) => state.Allstages?.stage);

//   // Reset filters when dialog opens
//   useEffect(() => {
//     if (open) {
//       console.log('🔄 Dialog opened - resetting filters');
//       setFilters({ ...defaultFilters });
//       setTempFilters({ ...defaultFilters });
//       setPage(1);
//       setRowsPerPage(5);
//       setComments([]);
//       setTotalCount(0);
//       setTotalPages(1);
//       setHasNextPage(false);
//       setHasPrevPage(false);

//       const loadStages = async () => {
//         setStagesLoading(true);
//         try {
//           await dispatch(GetAll_stage_Data());
//         } catch (error) {
//           console.error('Error loading stages:', error);
//         } finally {
//           setStagesLoading(false);
//         }
//       };

//       loadStages();
//     }
//   }, [open, dispatch]);

//   // Load initial data when dialog opens
//   useEffect(() => {
//     if (open && userlogin?.data?._id) {
//       console.log('📥 Loading initial comments with default filters');
//       loadComments(1, defaultFilters);
//     }
//   }, [open, userlogin]);

//   // Process stages when they come from Redux
//   // Process stages when they come from Redux
//   useEffect(() => {
//     if (All_stages?.data) {
//       console.log('📥 Stages loaded:', All_stages.data);

//       // فلترة المراحل المطلوبة
//       const filteredStages = All_stages.data.filter((stage) =>
//         ['Meeting', 'EOI', 'Done Deal'].includes(stage.name),
//       );

//       console.log(
//         '🎯 Filtered stages with IDs:',
//         filteredStages.map((s) => ({ name: s.name, id: s._id })),
//       );
//       setAllStages(filteredStages);

//       const stageNames = filteredStages.map((stage) => stage.name);
//       setUniqueStages(stageNames);

//       // لو فيه فلتر نشط والمراحل اتحملت دلوقتي، نعيد تحميل الكومنتس
//       if (filters.stage !== 'all' && userlogin?.data?._id) {
//         console.log('🔄 Stages loaded, refreshing with current filter:', filters.stage);
//         loadComments(page, filters, rowsPerPage);
//       }
//     }
//   }, [All_stages]);

//   // Process comments when Redux updates
//   useEffect(() => {
//     if (resgetallcoments && open) {
//       console.log('🔄 Processing comments from Redux:', resgetallcoments);

//       let commentsData = [];
//       let paginationData = {};

//       if (resgetallcoments?.data?.data && resgetallcoments?.data?.pagination) {
//         commentsData = resgetallcoments.data.data;
//         paginationData = resgetallcoments.data.pagination;
//         console.log('📊 Pagination data from data.pagination:', paginationData);
//       } else if (resgetallcoments?.data && resgetallcoments?.pagination) {
//         commentsData = resgetallcoments.data;
//         paginationData = resgetallcoments.pagination;
//         console.log('📊 Pagination data from root:', paginationData);
//       } else if (Array.isArray(resgetallcoments)) {
//         commentsData = resgetallcoments;
//         console.log('📊 No pagination data, just array');
//       } else if (resgetallcoments?.payload?.data) {
//         commentsData = resgetallcoments.payload.data;
//         paginationData = resgetallcoments.payload.pagination || {};
//         console.log('📊 Pagination data from payload:', paginationData);
//       }

//       console.log('✅ Processed comments:', commentsData.length);
//       console.log('📊 Final pagination data:', paginationData);

//       setComments(commentsData);

//       const total = paginationData.totalResults || paginationData.total || commentsData.length;
//       setTotalCount(total);
//       console.log('📈 Total count:', total);

//       if (paginationData.totalPages) {
//         setTotalPages(paginationData.totalPages);
//         console.log('📄 Total pages from pagination:', paginationData.totalPages);
//       } else {
//         const limit = paginationData.limit || rowsPerPage;
//         const calculatedPages = Math.ceil(total / limit);
//         setTotalPages(calculatedPages);
//         console.log('📄 Calculated total pages:', calculatedPages, 'with limit:', limit);
//       }

//       setHasNextPage(paginationData.hasNextPage === true);
//       setHasPrevPage(paginationData.hasPrevPage === true);

//       if (paginationData.page) {
//         setPage(paginationData.page);
//         console.log('📄 Current page:', paginationData.page);
//       }

//       if (paginationData.limit && paginationData.limit !== rowsPerPage) {
//         console.log('📊 Updating rowsPerPage to:', paginationData.limit);
//         setRowsPerPage(paginationData.limit);
//       }

//       setLoading(false);
//     }
//   }, [resgetallcoments, open, rowsPerPage]);

//   // Load comments function with filters
//   // Load comments function with filters
//   // Load comments function with filters
//   const loadComments = async (pageNum = page, filtersToUse = filters, customLimit = null) => {
//     if (!userlogin?.data?._id) {
//       Notify('error', 'User ID not found', 'error');
//       return;
//     }

//     setLoading(true);
//     try {
//       console.log('📥 Loading comments for user:', userlogin.data._id);
//       console.log('🎯 With filters:', filtersToUse);
//       console.log('📄 Page:', pageNum, 'Limit:', customLimit || rowsPerPage);

//       const queryParams = new URLSearchParams();
//       queryParams.append('page', pageNum);
//       queryParams.append('limit', customLimit || rowsPerPage);

//       // ✅ التعديل المهم هنا - إرسال ID الـ stage
//       if (filtersToUse.stage && filtersToUse.stage !== 'all') {
//         // دور على الـ stage بالاسم في allStages
//         const selectedStage = allStages.find((s) => s.name === filtersToUse.stage);

//         if (selectedStage) {
//           // إرسال ID الـ stage
//           queryParams.append('stage', selectedStage._id);
//           console.log('🎯 Sending Stage ID:', selectedStage._id, 'for stage:', filtersToUse.stage);
//         } else {
//           console.log('⚠️ Stage not found in allStages:', filtersToUse.stage);
//           // لو مش لاقي، جرب uniqueStages (لو فيها البيانات)
//           const stageIndex = uniqueStages.indexOf(filtersToUse.stage);
//           if (stageIndex !== -1 && allStages[stageIndex]) {
//             queryParams.append('stage', allStages[stageIndex]._id);
//             console.log('🎯 Found stage by index:', allStages[stageIndex]._id);
//           }
//         }
//       }

//       if (filtersToUse.searchTerm) {
//         queryParams.append('searchTerm', filtersToUse.searchTerm);
//       }

//       if (filtersToUse.createdFrom) queryParams.append('createdFrom', filtersToUse.createdFrom);
//       if (filtersToUse.createdTo) queryParams.append('createdTo', filtersToUse.createdTo);
//       if (filtersToUse.stageDateFrom)
//         queryParams.append('stageDateFrom', filtersToUse.stageDateFrom);
//       if (filtersToUse.stageDateTo) queryParams.append('stageDateTo', filtersToUse.stageDateTo);

//       queryParams.append(
//         'sort',
//         filtersToUse.sortOrder === 'desc' ? `-${filtersToUse.sortBy}` : filtersToUse.sortBy,
//       );

//       const queryString = queryParams.toString();
//       const url = `${userlogin.data._id}${queryString ? `?${queryString}` : ''}`;

//       console.log('🔗 Final URL:', url);
//       console.log('📤 Sending to backend with params:', Object.fromEntries(queryParams));

//       await dispatch(Get_AllComments_For_Sheet_By_User_Action(url));
//     } catch (error) {
//       console.error('❌ Error loading comments:', error);
//       Notify('error', 'Failed to load comments', 'error');
//       setLoading(false);
//     }
//   };

//   // Handle filter change
//   const handleTempFilterChange = (field, value) => {
//     setTempFilters((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   // Apply filters
//   // Apply filters
//   // Apply filters
//   const handleApplyFilters = () => {
//     console.log('🎯 Applying filters:', tempFilters);
//     setFilters({ ...tempFilters });
//     setPage(1);

//     // لو المراحل لسه متحملتش، هنستنى شوية
//     if (allStages.length === 0) {
//       console.log('⏳ Stages not loaded yet, waiting...');
//       // هنخزن الفلاتر مؤقتاً والـ useEffect بتاع المراحل هيتولى الباقي
//       setFilters({ ...tempFilters });
//     } else {
//       loadComments(1, tempFilters);
//     }

//     Notify('info', 'Filters applied successfully', 'info');
//   };

//   // Clear all filters
//   const clearFilters = () => {
//     console.log('🧹 Clearing all filters');
//     setTempFilters({ ...defaultFilters });
//     setFilters({ ...defaultFilters });
//     setPage(1);
//     loadComments(1, defaultFilters);
//     Notify('success', 'All filters cleared', 'success');
//   };

//   // Handle sort from table header
//   const handleSort = (field) => {
//     const newSortOrder = filters.sortBy === field && filters.sortOrder === 'asc' ? 'desc' : 'asc';
//     const newFilters = {
//       ...filters,
//       sortBy: field,
//       sortOrder: newSortOrder,
//     };
//     setFilters(newFilters);
//     setTempFilters(newFilters);
//     setPage(1);
//     loadComments(1, newFilters);
//   };

//   // Handle page change
//   const handlePageChange = (newPage) => {
//     console.log('📄 Changing to page:', newPage);
//     setPage(newPage);
//     loadComments(newPage, filters);
//   };

//   // Handle rows per page change
//   const handleRowsPerPageChange = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     console.log('📊 Changing rows per page to:', newRowsPerPage);

//     setRowsPerPage(newRowsPerPage);
//     setPage(1);
//     loadComments(1, filters, newRowsPerPage);
//   };

//   // Go to first page
//   const handleFirstPage = () => {
//     if (page > 1) {
//       handlePageChange(1);
//     }
//   };

//   // Go to last page
//   const handleLastPage = () => {
//     if (page < totalPages) {
//       handlePageChange(totalPages);
//     }
//   };

//   // Go to previous page
//   const handlePrevPage = () => {
//     if (hasPrevPage) {
//       handlePageChange(page - 1);
//     }
//   };

//   // Go to next page
//   const handleNextPage = () => {
//     if (hasNextPage) {
//       handlePageChange(page + 1);
//     }
//   };

//   // Export to Excel
//   const exportToExcel = () => {
//     if (comments.length === 0) {
//       Notify('warning', 'No data to export', 'warning');
//       return;
//     }

//     try {
//       const exportData = comments.map((comment) => ({
//         Date: comment.createdAt ? moment(comment.createdAt).format('DD/MM/YYYY HH:mm') : 'N/A',
//         'Lead Name': comment.lead?.name || 'N/A',
//         'Lead Phone': comment.lead?.phone || 'N/A',
//         'Lead Email': comment.lead?.email || 'N/A',
//         Stage: comment.stage?.name || 'N/A',
//         Comment: comment.comment || 'N/A',
//         'Developer Name': comment.salesdeveloperName || 'N/A',
//         'Stage Date': comment.stageDate
//           ? moment(comment.stageDate).format('DD/MM/YYYY HH:mm')
//           : 'N/A',
//         'Comment By': comment.commentBy?.name || 'N/A',
//         'Comment By Role': comment.commentBy?.role || 'N/A',
//       }));

//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const wscols = [
//         { wch: 20 },
//         { wch: 25 },
//         { wch: 15 },
//         { wch: 30 },
//         { wch: 15 },
//         { wch: 50 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 15 },
//       ];
//       ws['!cols'] = wscols;

//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, 'My Comments');

//       const fileName = `my_comments_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//       XLSX.writeFile(wb, fileName);

//       Notify('success', `Exported ${comments.length} comments to Excel`, 'success');
//     } catch (error) {
//       console.error('❌ Export error:', error);
//       Notify('error', 'Failed to export to Excel', 'error');
//     }
//   };

//   // Get stage color
//   const getStageColor = (stageName) => {
//     const colors = {
//       Meeting: '#f97316',
//       EOI: '#3b82f6',
//       'Done Deal': '#22c55e',
//       'Follow Up': '#a855f7',
//       'No Answer': '#ef4444',
//       Answer: '#22c55e',
//       Pending: '#f97316',
//       Fresh: '#06b6d4',
//       Transfer: '#f97316',
//     };
//     return colors[stageName] || '#6b7280';
//   };

//   // Get stage icon
//   const getStageIcon = (stageName) => {
//     switch (stageName) {
//       case 'Meeting':
//         return <ScheduleIcon />;
//       case 'EOI':
//         return <TrendingUpIcon />;
//       case 'Done Deal':
//         return <CheckCircleIcon />;
//       case 'Follow Up':
//         return <RefreshIcon />;
//       case 'No Answer':
//         return <CloseIcon />;
//       case 'Answer':
//         return <PhoneIcon />;
//       default:
//         return <CommentIcon />;
//     }
//   };

//   // Calculate active filters count
//   const activeFilterCount = useMemo(() => {
//     let count = 0;
//     if (filters.stage !== 'all') count++;
//     if (filters.searchTerm) count++;
//     if (filters.createdFrom) count++;
//     if (filters.createdTo) count++;
//     if (filters.stageDateFrom) count++;
//     if (filters.stageDateTo) count++;
//     return count;
//   }, [filters]);

//   // Calculate statistics
//   const statistics = useMemo(() => {
//     const stats = {
//       total: comments.length,
//       byStage: {},
//       recent: 0,
//     };

//     comments.forEach((comment) => {
//       const stageName = comment.stage?.name || 'Unknown';
//       stats.byStage[stageName] = (stats.byStage[stageName] || 0) + 1;

//       if (moment(comment.createdAt).isAfter(moment().subtract(7, 'days'))) {
//         stats.recent++;
//       }
//     });

//     return stats;
//   }, [comments]);

//   // Generate page numbers to display
//   const getPageNumbers = () => {
//     const delta = 2;
//     const range = [];
//     const rangeWithDots = [];
//     let l;

//     for (let i = 1; i <= totalPages; i++) {
//       if (i === 1 || i === totalPages || (i >= page - delta && i <= page + delta)) {
//         range.push(i);
//       }
//     }

//     range.forEach((i) => {
//       if (l) {
//         if (i - l === 2) {
//           rangeWithDots.push(l + 1);
//         } else if (i - l !== 1) {
//           rangeWithDots.push('...');
//         }
//       }
//       rangeWithDots.push(i);
//       l = i;
//     });

//     return rangeWithDots;
//   };

//   return (
//     <>
//       <StyledDialog
//         open={open}
//         onClose={onClose}
//         maxWidth="lg"
//         fullWidth
//         TransitionComponent={Fade}
//         transitionDuration={500}
//         // ✅ إضافة الـ sx هنا هو الحل السحري
//         sx={{
//           zIndex: 50000,
//           '& .MuiDialog-container': {
//             overflow: 'visible',
//             zIndex: 50000,
//             position: 'relative',
//           },
//           '& .MuiBackdrop-root': {
//             zIndex: 49999,
//           },
//           // ✅ هذا هو المفتاح لحل مشكلة الـ Select و Autocomplete
//           '& .MuiModal-root': {
//             zIndex: '50001 !important',
//           },
//           '& .MuiPopover-root, & .MuiMenu-root': {
//             zIndex: '50001 !important',
//             '& .MuiPaper-root': {
//               zIndex: '50001 !important',
//             },
//           },
//           '& .MuiPopper-root': {
//             zIndex: '50001 !important',
//           },
//           '& [role="listbox"]': {
//             zIndex: '50001 !important',
//           },
//           // ✅ للـ Select داخل الفلاتر
//           '& .MuiSelect-select': {
//             position: 'relative',
//             zIndex: 50000,
//           },
//         }}
//       >
//         {/* Header */}
//         <HeaderGradient>
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               position: 'relative',
//               zIndex: 1000000,
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
//               <Avatar
//                 sx={{
//                   bgcolor: 'rgba(255,255,255,0.2)',
//                   width: 64,
//                   height: 64,
//                   border: '3px solid rgba(255,255,255,0.3)',
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//                 }}
//               >
//                 <AssignmentIcon sx={{ fontSize: 36 }} />
//               </Avatar>
//               <Box>
//                 <Typography variant="h4" fontWeight={800} letterSpacing={0.5} sx={{ mb: 0.5 }}>
//                   My Private Sheet
//                 </Typography>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <PersonIcon fontSize="small" sx={{ opacity: 0.8 }} />
//                     <Typography variant="body1" sx={{ opacity: 0.9, fontWeight: 500 }}>
//                       {userlogin?.data?.name || 'User'}
//                     </Typography>
//                   </Box>
//                   <Chip
//                     icon={<CommentIcon />}
//                     label={`${totalCount} Comments`}
//                     size="small"
//                     sx={{
//                       backgroundColor: 'rgba(255,255,255,0.2)',
//                       color: 'white',
//                       fontWeight: 600,
//                       backdropFilter: 'blur(4px)',
//                       '& .MuiChip-icon': { color: 'white' },
//                     }}
//                   />
//                   {activeFilterCount > 0 && (
//                     <Chip
//                       label={`${activeFilterCount} Active Filters`}
//                       size="small"
//                       sx={{
//                         backgroundColor: '#f97316',
//                         color: 'white',
//                         fontWeight: 600,
//                         animation: 'pulse 2s infinite',
//                       }}
//                     />
//                   )}
//                 </Box>
//               </Box>
//             </Box>

//             <Box sx={{ display: 'flex', gap: 1.5 }}>
//               <Tooltip title="Statistics">
//                 <IconButton
//                   onClick={() => setStatsExpanded(!statsExpanded)}
//                   sx={{
//                     color: 'white',
//                     bgcolor: statsExpanded ? 'rgba(255,255,255,0.2)' : 'transparent',
//                     '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
//                     transition: 'all 0.2s',
//                   }}
//                 >
//                   <BarChartIcon />
//                 </IconButton>
//               </Tooltip>

//               <Tooltip title="Refresh">
//                 <IconButton
//                   onClick={() => loadComments(page)}
//                   disabled={loading}
//                   sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' } }}
//                 >
//                   <RefreshIcon />
//                 </IconButton>
//               </Tooltip>

//               <Tooltip title="Export to Excel">
//                 <IconButton
//                   onClick={exportToExcel}
//                   disabled={comments.length === 0}
//                   sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' } }}
//                 >
//                   <DownloadIcon />
//                 </IconButton>
//               </Tooltip>

//               <IconButton
//                 onClick={onClose}
//                 sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' } }}
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </Box>
//         </HeaderGradient>

//         {/* Content */}
//         <DialogContent sx={{ p: 3, backgroundColor: mode === 'dark' ? '#0f172a' : '#f8fafc' }}>
//           {/* Statistics Section */}
//           <Collapse in={statsExpanded}>
//             <Zoom in={statsExpanded}>
//               <Box sx={{ mb: 3 }}>
//                 <Typography
//                   variant="h6"
//                   gutterBottom
//                   fontWeight={600}
//                   sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#2563eb' }}
//                 >
//                   <BarChartIcon />
//                   Statistics Overview
//                 </Typography>

//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <StatsCard>
//                       <CardContent>
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'space-between',
//                           }}
//                         >
//                           <Box>
//                             <Typography
//                               color="textSecondary"
//                               gutterBottom
//                               variant="body2"
//                               fontWeight={500}
//                             >
//                               Total Comments
//                             </Typography>
//                             <Typography variant="h3" fontWeight={700} sx={{ color: '#2563eb' }}>
//                               {statistics.total}
//                             </Typography>
//                           </Box>
//                           <Avatar sx={{ bgcolor: '#2563eb', width: 56, height: 56 }}>
//                             <CommentIcon sx={{ fontSize: 28 }} />
//                           </Avatar>
//                         </Box>
//                       </CardContent>
//                     </StatsCard>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <StatsCard>
//                       <CardContent>
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'space-between',
//                           }}
//                         >
//                           <Box>
//                             <Typography
//                               color="textSecondary"
//                               gutterBottom
//                               variant="body2"
//                               fontWeight={500}
//                             >
//                               Last 7 Days
//                             </Typography>
//                             <Typography variant="h3" fontWeight={700} sx={{ color: '#22c55e' }}>
//                               {statistics.recent}
//                             </Typography>
//                           </Box>
//                           <Avatar sx={{ bgcolor: '#22c55e', width: 56, height: 56 }}>
//                             <TrendingUpIcon sx={{ fontSize: 28 }} />
//                           </Avatar>
//                         </Box>
//                       </CardContent>
//                     </StatsCard>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <StatsCard>
//                       <CardContent>
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'space-between',
//                           }}
//                         >
//                           <Box>
//                             <Typography
//                               color="textSecondary"
//                               gutterBottom
//                               variant="body2"
//                               fontWeight={500}
//                             >
//                               Unique Stages
//                             </Typography>
//                             <Typography variant="h3" fontWeight={700} sx={{ color: '#a855f7' }}>
//                               {Object.keys(statistics.byStage).length}
//                             </Typography>
//                           </Box>
//                           <Avatar sx={{ bgcolor: '#a855f7', width: 56, height: 56 }}>
//                             <PieChartIcon sx={{ fontSize: 28 }} />
//                           </Avatar>
//                         </Box>
//                       </CardContent>
//                     </StatsCard>
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Zoom>
//           </Collapse>

//           {/* Filters Section */}
//           <FilterPaper elevation={0}>
//             <Box
//               sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <FilterListIcon sx={{ color: '#2563eb' }} />
//                 <Typography variant="h6" fontWeight={600} sx={{ color: '#2563eb' }}>
//                   Advanced Filters
//                   {activeFilterCount > 0 && (
//                     <Chip
//                       label={activeFilterCount}
//                       size="small"
//                       sx={{
//                         ml: 1,
//                         fontWeight: 600,
//                         bgcolor: '#2563eb',
//                         color: 'white',
//                       }}
//                     />
//                   )}
//                 </Typography>
//               </Box>
//               <IconButton
//                 onClick={() => setFilterExpanded(!filterExpanded)}
//                 size="small"
//                 sx={{ color: '#2563eb' }}
//               >
//                 {filterExpanded ? <TrendingUpIcon /> : <TrendingDownIcon />}
//               </IconButton>
//             </Box>

//             <Collapse in={filterExpanded}>
//               <Grid container spacing={2}>
//                 {/* Search Input */}
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Search by Lead Name, Phone or Sales Developer"
//                     value={tempFilters.searchTerm}
//                     onChange={(e) => handleTempFilterChange('searchTerm', e.target.value)}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <SearchIcon sx={{ color: '#2563eb' }} />
//                         </InputAdornment>
//                       ),
//                       endAdornment: tempFilters.searchTerm && (
//                         <InputAdornment position="end">
//                           <IconButton
//                             size="small"
//                             onClick={() => handleTempFilterChange('searchTerm', '')}
//                           >
//                             <ClearIcon fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                     placeholder="Type to search..."
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 2,
//                         '&:hover fieldset': {
//                           borderColor: '#2563eb',
//                         },
//                       },
//                     }}
//                   />
//                 </Grid>

//                 {/* Stage Filter */}
//                 <Grid item xs={12} md={6}>
//                   <FormControl fullWidth size="small">
//                     <InputLabel>Stage</InputLabel>
//                     <Select
//                       value={tempFilters.stage}
//                       onChange={(e) => handleTempFilterChange('stage', e.target.value)}
//                       label="Stage"
//                       disabled={stagesLoading}
//                       // ✅ إضافة MenuProps لضبط z-index
//                       MenuProps={{
//                         sx: {
//                           zIndex: 50001,
//                         },
//                         PaperProps: {
//                           sx: {
//                             zIndex: 50001,
//                             boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
//                           },
//                         },
//                       }}
//                     >
//                       <MenuItem value="all">All Stages</MenuItem>
//                       {stagesLoading ? (
//                         <MenuItem disabled>
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <CircularProgress size={16} />
//                             Loading stages...
//                           </Box>
//                         </MenuItem>
//                       ) : (
//                         allStages.map((stage) => (
//                           <MenuItem key={stage._id} value={stage.name}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                               <Box
//                                 sx={{
//                                   width: 20,
//                                   height: 20,
//                                   borderRadius: '50%',
//                                   bgcolor: getStageColor(stage.name),
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                 }}
//                               >
//                                 {stage.name === 'Meeting' && (
//                                   <ScheduleIcon sx={{ fontSize: 12, color: 'white' }} />
//                                 )}
//                                 {stage.name === 'EOI' && (
//                                   <TrendingUpIcon sx={{ fontSize: 12, color: 'white' }} />
//                                 )}
//                                 {stage.name === 'Done Deal' && (
//                                   <CheckCircleIcon sx={{ fontSize: 12, color: 'white' }} />
//                                 )}
//                               </Box>
//                               <Typography>{stage.name}</Typography>
//                             </Box>
//                           </MenuItem>
//                         ))
//                       )}
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 {/* Created From */}
//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Created From"
//                     type="date"
//                     value={tempFilters.createdFrom}
//                     onChange={(e) => handleTempFilterChange('createdFrom', e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <CalendarTodayIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>

//                 {/* Created To */}
//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Created To"
//                     type="date"
//                     value={tempFilters.createdTo}
//                     onChange={(e) => handleTempFilterChange('createdTo', e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <CalendarTodayIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>

//                 {/* Stage Date From */}
//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Stage Date From"
//                     type="date"
//                     value={tempFilters.stageDateFrom}
//                     onChange={(e) => handleTempFilterChange('stageDateFrom', e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <ScheduleIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>

//                 {/* Stage Date To */}
//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     label="Stage Date To"
//                     type="date"
//                     value={tempFilters.stageDateTo}
//                     onChange={(e) => handleTempFilterChange('stageDateTo', e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <ScheduleIcon fontSize="small" sx={{ color: '#2563eb' }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>

//                 {/* Sort Order */}
//                 <Grid item xs={12} md={4}>
//                   <FormControl fullWidth size="small">
//                     <InputLabel>Sort Order</InputLabel>
//                     <Select
//                       value={tempFilters.sortOrder}
//                       onChange={(e) => handleTempFilterChange('sortOrder', e.target.value)}
//                       label="Sort Order"
//                       // ✅ إضافة MenuProps لضبط z-index
//                       MenuProps={{
//                         sx: {
//                           zIndex: 50001,
//                         },
//                         PaperProps: {
//                           sx: {
//                             zIndex: 50001,
//                           },
//                         },
//                       }}
//                     >
//                       <MenuItem value="desc">⬇️ Newest First</MenuItem>
//                       <MenuItem value="asc">⬆️ Oldest First</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 {/* Action Buttons */}
//                 <Grid item xs={12} md={8}>
//                   <Box sx={{ display: 'flex', gap: 1 }}>
//                     <Button
//                       fullWidth
//                       variant="contained"
//                       onClick={handleApplyFilters}
//                       startIcon={<PlayArrowIcon />}
//                       sx={{
//                         height: '40px',
//                         background: 'linear-gradient(45deg, #2563eb 30%, #7c3aed 90%)',
//                         '&:hover': {
//                           background: 'linear-gradient(45deg, #1d4ed8 30%, #6d28d9 90%)',
//                         },
//                       }}
//                     >
//                       Apply Filters
//                     </Button>

//                     <Button
//                       variant="outlined"
//                       onClick={clearFilters}
//                       startIcon={<ClearIcon />}
//                       disabled={activeFilterCount === 0}
//                       sx={{
//                         height: '40px',
//                         minWidth: '120px',
//                         borderColor: '#2563eb',
//                         color: '#2563eb',
//                         '&:hover': {
//                           borderColor: '#1d4ed8',
//                           backgroundColor: 'rgba(37, 99, 235, 0.05)',
//                         },
//                       }}
//                     >
//                       Clear
//                     </Button>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Collapse>
//           </FilterPaper>

//           {/* Table Section */}
//           {loading ? (
//             <Box sx={{ position: 'relative', py: 8 }}>
//               <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, right: 0 }} />
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
//                 <CircularProgress size={60} thickness={4} sx={{ color: '#2563eb' }} />
//               </Box>
//             </Box>
//           ) : comments.length === 0 ? (
//             <EmptyState mode={mode} onRefresh={() => loadComments(1)} />
//           ) : (
//             <Grow in timeout={500}>
//               <Box>
//                 {/* Results Summary */}
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     mb: 2,
//                     p: 1.5,
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(37, 99, 235, 0.1)' : 'rgba(37, 99, 235, 0.05)',
//                     borderRadius: 2,
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <TableChartIcon sx={{ color: '#2563eb', fontSize: 20 }} />
//                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                       Showing{' '}
//                       <strong style={{ color: '#2563eb' }}>
//                         {totalCount > 0
//                           ? `${(page - 1) * rowsPerPage + 1} - ${Math.min(page * rowsPerPage, totalCount)}`
//                           : '0'}
//                       </strong>{' '}
//                       of <strong style={{ color: '#2563eb' }}>{totalCount}</strong> comments
//                       {activeFilterCount > 0 && ' (filtered)'}
//                     </Typography>
//                   </Box>
//                   <Chip
//                     label={`Page ${page} of ${totalPages}`}
//                     size="small"
//                     sx={{
//                       backgroundColor: '#2563eb',
//                       color: 'white',
//                       fontWeight: 600,
//                     }}
//                   />
//                 </Box>

//                 {/* Table View */}
//                 <TableContainer
//                   component={Paper}
//                   sx={{
//                     borderRadius: 4,
//                     overflow: 'hidden',
//                     boxShadow:
//                       mode === 'dark'
//                         ? '0 8px 32px rgba(0,0,0,0.3)'
//                         : '0 8px 32px rgba(37, 99, 235, 0.1)',
//                     border: `1px solid ${mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(37, 99, 235, 0.1)'}`,
//                   }}
//                 >
//                   <Table stickyHeader size="small">
//                     <TableHead>
//                       <TableRow>
//                         <StyledTableCell>
//                           <TableSortLabel
//                             active={filters.sortBy === 'createdAt'}
//                             direction={filters.sortBy === 'createdAt' ? filters.sortOrder : 'asc'}
//                             onClick={() => handleSort('createdAt')}
//                             sx={{
//                               '& .MuiTableSortLabel-icon': {
//                                 color: '#2563eb !important',
//                               },
//                             }}
//                           >
//                             📅 Date
//                           </TableSortLabel>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <TableSortLabel
//                             active={filters.sortBy === 'leadName'}
//                             direction={filters.sortBy === 'leadName' ? filters.sortOrder : 'asc'}
//                             onClick={() => handleSort('leadName')}
//                             sx={{
//                               '& .MuiTableSortLabel-icon': {
//                                 color: '#2563eb !important',
//                               },
//                             }}
//                           >
//                             👤 Lead Info
//                           </TableSortLabel>
//                         </StyledTableCell>
//                         <StyledTableCell>
//                           <TableSortLabel
//                             active={filters.sortBy === 'stageName'}
//                             direction={filters.sortBy === 'stageName' ? filters.sortOrder : 'asc'}
//                             onClick={() => handleSort('stageName')}
//                             sx={{
//                               '& .MuiTableSortLabel-icon': {
//                                 color: '#2563eb !important',
//                               },
//                             }}
//                           >
//                             📍 Stage
//                           </TableSortLabel>
//                         </StyledTableCell>
//                         <StyledTableCell>💬 Comment</StyledTableCell>
//                         <StyledTableCell>
//                           <TableSortLabel
//                             active={filters.sortBy === 'salesdeveloperName'}
//                             direction={
//                               filters.sortBy === 'salesdeveloperName' ? filters.sortOrder : 'asc'
//                             }
//                             onClick={() => handleSort('salesdeveloperName')}
//                             sx={{
//                               '& .MuiTableSortLabel-icon': {
//                                 color: '#2563eb !important',
//                               },
//                             }}
//                           >
//                             👨‍💻 Sales Developer
//                           </TableSortLabel>
//                         </StyledTableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {comments.map((comment, index) => (
//                         <StyledTableRow
//                           key={comment._id || index}
//                           sx={{
//                             animation: `fadeIn ${0.3 + index * 0.05}s ease-in-out`,
//                             backgroundColor:
//                               index % 2 === 0
//                                 ? mode === 'dark'
//                                   ? 'rgba(255,255,255,0.02)'
//                                   : 'rgba(37, 99, 235, 0.02)'
//                                 : 'transparent',
//                             cursor: 'pointer',
//                             '&:hover': {
//                               backgroundColor:
//                                 mode === 'dark'
//                                   ? 'rgba(37, 99, 235, 0.2)'
//                                   : 'rgba(37, 99, 235, 0.1)',
//                             },
//                           }}
//                           onClick={() => {
//                             setSelectedComment(comment);
//                             setDetailsOpen(true);
//                           }}
//                         >
//                           <StyledTableCell>
//                             <Box>
//                               <Typography variant="body2" fontWeight={600}>
//                                 {comment.createdAt
//                                   ? moment(comment.createdAt).format('DD/MM/YYYY')
//                                   : 'N/A'}
//                               </Typography>
//                               <Typography variant="caption" color="textSecondary">
//                                 {comment.createdAt
//                                   ? moment(comment.createdAt).format('hh:mm A')
//                                   : ''}
//                               </Typography>
//                             </Box>
//                           </StyledTableCell>

//                           <StyledTableCell>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                               <Avatar
//                                 sx={{
//                                   width: 40,
//                                   height: 40,
//                                   bgcolor: comment.lead?.name ? '#2563eb' : '#94a3b8',
//                                   border: '2px solid',
//                                   borderColor: 'white',
//                                   boxShadow: '0 2px 8px rgba(37, 99, 235, 0.2)',
//                                 }}
//                               >
//                                 {comment.lead?.name?.charAt(0) || '?'}
//                               </Avatar>
//                               <Box>
//                                 <Typography variant="body2" fontWeight={600}>
//                                   {comment.lead?.name || 'N/A'}
//                                 </Typography>
//                                 {comment.lead?.phone && (
//                                   <Typography
//                                     variant="caption"
//                                     color="textSecondary"
//                                     sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
//                                   >
//                                     <PhoneIcon sx={{ fontSize: 12 }} />
//                                     {comment.lead.phone}
//                                   </Typography>
//                                 )}
//                               </Box>
//                             </Box>
//                           </StyledTableCell>

//                           <StyledTableCell>
//                             <Chip
//                               icon={getStageIcon(comment.stage?.name)}
//                               label={comment.stage?.name || 'N/A'}
//                               size="small"
//                               sx={{
//                                 backgroundColor: getStageColor(comment.stage?.name),
//                                 color: 'white',
//                                 fontWeight: 600,
//                                 fontSize: '0.75rem',
//                                 '& .MuiChip-icon': {
//                                   color: 'white',
//                                   fontSize: 14,
//                                 },
//                               }}
//                             />
//                             {comment.stageDate && (
//                               <Typography
//                                 variant="caption"
//                                 color="textSecondary"
//                                 sx={{ display: 'block', mt: 0.5 }}
//                               >
//                                 {moment(comment.stageDate).format('DD/MM/YYYY')}
//                               </Typography>
//                             )}
//                           </StyledTableCell>

//                           <StyledTableCell>
//                             <Tooltip title={comment.comment || ''} arrow>
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   maxWidth: 250,
//                                   overflow: 'hidden',
//                                   textOverflow: 'ellipsis',
//                                   whiteSpace: 'nowrap',
//                                   cursor: 'help',
//                                   p: 0.5,
//                                   borderRadius: 1,
//                                   '&:hover': {
//                                     backgroundColor:
//                                       mode === 'dark'
//                                         ? 'rgba(255,255,255,0.1)'
//                                         : 'rgba(37, 99, 235, 0.1)',
//                                   },
//                                 }}
//                               >
//                                 {comment.comment || 'N/A'}
//                               </Typography>
//                             </Tooltip>
//                           </StyledTableCell>

//                           <StyledTableCell>
//                             <Typography variant="body2" fontWeight={500}>
//                               {comment.salesdeveloperName || 'N/A'}
//                             </Typography>
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 {/* Custom Pagination with Page Numbers */}
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     display: 'flex',
//                     flexDirection: { xs: 'column', sm: 'row' },
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     gap: 2,
//                     mt: 3,
//                     p: 2,
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(37, 99, 235, 0.1)' : 'rgba(37, 99, 235, 0.05)',
//                     borderRadius: 2,
//                     border: `1px solid ${mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(37, 99, 235, 0.2)'}`,
//                   }}
//                 >
//                   {/* Left side - Rows per page selector */}
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontWeight: 500,
//                         color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                       }}
//                     >
//                       Show:
//                     </Typography>
//                     <FormControl size="small" sx={{ minWidth: 100 }}>
//                       <Select
//                         value={rowsPerPage}
//                         onChange={handleRowsPerPageChange}
//                         displayEmpty
//                         // ✅ إضافة MenuProps لضبط z-index
//                         MenuProps={{
//                           sx: {
//                             zIndex: 50001,
//                           },
//                           PaperProps: {
//                             sx: {
//                               zIndex: 50001,
//                             },
//                           },
//                         }}
//                         sx={{
//                           height: 36,
//                           fontSize: '0.875rem',
//                           backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'white',
//                           color: mode === 'dark' ? 'white' : '#1e293b',
//                           '& .MuiOutlinedInput-notchedOutline': {
//                             borderColor:
//                               mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(37, 99, 235, 0.3)',
//                           },
//                           '&:hover .MuiOutlinedInput-notchedOutline': {
//                             borderColor: '#2563eb',
//                           },
//                         }}
//                       >
//                         <MenuItem value={5}>5 per page</MenuItem>
//                         <MenuItem value={10}>10 per page</MenuItem>
//                         <MenuItem value={25}>25 per page</MenuItem>
//                         <MenuItem value={50}>50 per page</MenuItem>
//                         <MenuItem value={100}>100 per page</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Box>

//                   {/* Center - Page Numbers */}
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5,
//                       flexWrap: 'wrap',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     <Tooltip title="First Page">
//                       <span>
//                         <IconButton
//                           onClick={handleFirstPage}
//                           disabled={page === 1}
//                           size="small"
//                           sx={{
//                             color: '#2563eb',
//                             '&.Mui-disabled': {
//                               color:
//                                 mode === 'dark'
//                                   ? 'rgba(255,255,255,0.2)'
//                                   : 'rgba(37, 99, 235, 0.2)',
//                             },
//                           }}
//                         >
//                           <FirstPageIcon />
//                         </IconButton>
//                       </span>
//                     </Tooltip>

//                     <Tooltip title="Previous Page">
//                       <span>
//                         <IconButton
//                           onClick={handlePrevPage}
//                           disabled={!hasPrevPage}
//                           size="small"
//                           sx={{
//                             color: '#2563eb',
//                             '&.Mui-disabled': {
//                               color:
//                                 mode === 'dark'
//                                   ? 'rgba(255,255,255,0.2)'
//                                   : 'rgba(37, 99, 235, 0.2)',
//                             },
//                           }}
//                         >
//                           <KeyboardArrowLeftIcon />
//                         </IconButton>
//                       </span>
//                     </Tooltip>

//                     {/* Page Number Buttons */}
//                     {getPageNumbers().map((pageNumber, index) =>
//                       pageNumber === '...' ? (
//                         <Typography
//                           key={`dots-${index}`}
//                           sx={{
//                             px: 1,
//                             color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           }}
//                         >
//                           ...
//                         </Typography>
//                       ) : (
//                         <Button
//                           key={pageNumber}
//                           onClick={() => handlePageChange(pageNumber)}
//                           variant={page === pageNumber ? 'contained' : 'outlined'}
//                           size="small"
//                           sx={{
//                             minWidth: 36,
//                             height: 36,
//                             borderRadius: '8px',
//                             fontWeight: page === pageNumber ? 700 : 500,
//                             backgroundColor: page === pageNumber ? '#2563eb' : 'transparent',
//                             color:
//                               page === pageNumber ? 'white' : mode === 'dark' ? 'white' : '#2563eb',
//                             borderColor: '#2563eb',
//                             '&:hover': {
//                               backgroundColor:
//                                 page === pageNumber ? '#1d4ed8' : 'rgba(37, 99, 235, 0.1)',
//                               borderColor: '#1d4ed8',
//                             },
//                           }}
//                         >
//                           {pageNumber}
//                         </Button>
//                       ),
//                     )}

//                     <Tooltip title="Next Page">
//                       <span>
//                         <IconButton
//                           onClick={handleNextPage}
//                           disabled={!hasNextPage}
//                           size="small"
//                           sx={{
//                             color: '#2563eb',
//                             '&.Mui-disabled': {
//                               color:
//                                 mode === 'dark'
//                                   ? 'rgba(255,255,255,0.2)'
//                                   : 'rgba(37, 99, 235, 0.2)',
//                             },
//                           }}
//                         >
//                           <KeyboardArrowRightIcon />
//                         </IconButton>
//                       </span>
//                     </Tooltip>

//                     <Tooltip title="Last Page">
//                       <span>
//                         <IconButton
//                           onClick={handleLastPage}
//                           disabled={page === totalPages}
//                           size="small"
//                           sx={{
//                             color: '#2563eb',
//                             '&.Mui-disabled': {
//                               color:
//                                 mode === 'dark'
//                                   ? 'rgba(255,255,255,0.2)'
//                                   : 'rgba(37, 99, 235, 0.2)',
//                             },
//                           }}
//                         >
//                           <LastPageIcon />
//                         </IconButton>
//                       </span>
//                     </Tooltip>
//                   </Box>

//                   {/* Right side - Page info */}
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: 500,
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                     }}
//                   >
//                     Page {page} of {totalPages}
//                   </Typography>
//                 </Paper>

//                 {/* Progress bar */}
//                 <Box sx={{ mt: 2 }}>
//                   <LinearProgress
//                     variant="determinate"
//                     value={(page / totalPages) * 100}
//                     sx={{
//                       height: 4,
//                       borderRadius: 2,
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(37, 99, 235, 0.1)',
//                       '& .MuiLinearProgress-bar': {
//                         backgroundColor: '#2563eb',
//                         borderRadius: 2,
//                       },
//                     }}
//                   />
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
//                     <Typography variant="caption" color="textSecondary">
//                       Page {page} of {totalPages}
//                     </Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       {Math.round((page / totalPages) * 100)}% complete
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//             </Grow>
//           )}
//         </DialogContent>
//       </StyledDialog>

//       {/* Details Modal - باستخدام createPortal */}
//       <DetailsModal
//         open={detailsOpen}
//         onClose={() => setDetailsOpen(false)}
//         comment={selectedComment}
//         mode={mode}
//         getStageColor={getStageColor}
//         getStageIcon={getStageIcon}
//       />
//     </>
//   );
// };













// /20-5-2026

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import {
  Box, Typography, Avatar, Button, TextField,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Tooltip, InputAdornment, FormControl, Select, MenuItem,
  Grid, LinearProgress, IconButton, Fade, Divider,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon              from '@mui/icons-material/Close';
import RefreshIcon            from '@mui/icons-material/Refresh';
import SearchIcon             from '@mui/icons-material/Search';
import FilterListIcon         from '@mui/icons-material/FilterList';
import ClearIcon              from '@mui/icons-material/Clear';
import DownloadIcon           from '@mui/icons-material/Download';
import TableChartIcon         from '@mui/icons-material/TableChart';
import CommentIcon            from '@mui/icons-material/Comment';
import FirstPageIcon          from '@mui/icons-material/FirstPage';
import LastPageIcon           from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon  from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AssessmentIcon         from '@mui/icons-material/Assessment';
import PeopleAltIcon          from '@mui/icons-material/PeopleAlt';
import VisibilityIcon         from '@mui/icons-material/Visibility';
import PhoneIcon              from '@mui/icons-material/Phone';
import EmailIcon              from '@mui/icons-material/Email';
import OpenInNewIcon          from '@mui/icons-material/OpenInNew';
import GridViewIcon           from '@mui/icons-material/GridView';
import moment from 'moment';
import XLSX   from '../utils/excelUtils';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';
import { Get_AllComments_For_Sheet_By_User_Action } from '../Redux/Actions/MeetingCommentsAction';
import { GetAll_stage_Data }                        from '../Redux/Actions/Stage_Action';

// ══════════════════════════════════════════════════════════════
//  Styled Components — نفس بالظبط زي ShoweetingShwwtForAdmin
// ══════════════════════════════════════════════════════════════

const PanelHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark'
    ? 'linear-gradient(135deg, #0d1b3e 0%, #1a2a5e 100%)'
    : 'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)',
  padding: theme.spacing(2.5, 3.5),
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  flexShrink: 0, position: 'relative', overflow: 'hidden',
  '&::after':  { content: '""', position: 'absolute', top: '-40px',  right: '-40px',  width: 180, height: 180, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' },
  '&::before': { content: '""', position: 'absolute', bottom: '-60px', right: '120px', width: 140, height: 140, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' },
}));

const StatCard = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark' ? '#1e2132' : '#ffffff',
  borderRadius: 12,
  border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
  padding: theme.spacing(2),
  display: 'flex', alignItems: 'center', gap: 12,
  transition: 'all 0.2s ease',
  '&:hover': {
    borderColor: '#1d4ed8',
    transform: 'translateY(-1px)',
    boxShadow: theme.palette.mode === 'dark'
      ? '0 4px 20px rgba(0,0,0,0.3)'
      : '0 4px 20px rgba(29,78,216,0.1)',
  },
}));

const FilterPanel = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark' ? '#161929' : '#f8fafc',
  borderRadius: 12,
  border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(2),
}));

const StageTag = styled(Box)(({ chipcolor }) => ({
  display: 'inline-flex', alignItems: 'center', gap: 4,
  padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 0.4,
  backgroundColor: chipcolor + '18', color: chipcolor,
  border: `1px solid ${chipcolor}35`, whiteSpace: 'nowrap',
}));

const NavBtn = styled(IconButton)(({ theme }) => ({
  width: 30, height: 30, borderRadius: 6,
  border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
  background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#ffffff',
  color: theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b',
  '&:hover': { background: '#1d4ed8', borderColor: '#1d4ed8', color: '#ffffff' },
  '&.Mui-disabled': { opacity: 0.35 },
  transition: 'all 0.15s ease',
}));

const PgBtn = styled(Button)(({ theme, isactive }) => ({
  minWidth: 32, height: 32, borderRadius: 6, padding: 0, fontWeight: 600, fontSize: 13,
  transition: 'all 0.15s ease',
  ...(isactive === 'true'
    ? {
        background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
        color: '#ffffff', border: 'none',
        boxShadow: '0 2px 8px rgba(29,78,216,0.35)',
        '&:hover': { background: 'linear-gradient(135deg, #1e3a8a, #2563eb)' },
      }
    : {
        background: 'transparent',
        color: theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b',
        border: `1px solid ${theme.palette.mode === 'dark' ? '#2a2f45' : '#e2e8f0'}`,
        '&:hover': { borderColor: '#1d4ed8', color: '#1d4ed8', background: 'rgba(29,78,216,0.06)' },
      }),
}));

// ══════════════════════════════════════════════════════════════
//  Details Modal
// ══════════════════════════════════════════════════════════════

const DetailsModal = ({ open, onClose, comment, isDark, getStageColor }) => {
  if (!open || !comment) return null;

  const border = isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0';
  const secBg  = isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc';
  const txtSec = isDark ? '#94a3b8' : '#64748b';

  return ReactDOM.createPortal(
    <Fade in={open}>
      <Box sx={{ position: 'fixed', inset: 0, zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* Backdrop */}
        <Box
          onClick={onClose}
          sx={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(6px)', zIndex: 999998 }}
        />
        {/* Modal */}
        <Box sx={{
          borderRadius: 4,
          background: isDark ? '#1a1d2e' : '#ffffff',
          border: `1px solid ${border}`,
          width: 680, maxWidth: '92vw', maxHeight: '88vh', overflow: 'auto',
          position: 'relative', zIndex: 999999,
          boxShadow: '0 25px 80px rgba(0,0,0,0.35)',
        }}>
          {/* Header */}
          <Box sx={{ p: 2.5, borderBottom: `1px solid ${border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ width: 36, height: 36, borderRadius: 2, background: 'rgba(29,78,216,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <VisibilityIcon sx={{ fontSize: 18, color: '#1d4ed8' }} />
              </Box>
              <Typography sx={{ fontWeight: 700, fontSize: 16, color: isDark ? '#f1f5f9' : '#0f172a' }}>
                Comment Details
              </Typography>
            </Box>
            <NavBtn onClick={onClose}><CloseIcon sx={{ fontSize: 15 }} /></NavBtn>
          </Box>

          <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            {/* Lead Info */}
            <Box sx={{ p: 2, borderRadius: 2, background: secBg, border: `1px solid ${border}` }}>
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#1d4ed8', mb: 1.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                👤 Lead Information
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ width: 52, height: 52, background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)', fontSize: 20, fontWeight: 800 }}>
                  {comment.lead?.name?.charAt(0)?.toUpperCase() || '?'}
                </Avatar>
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: 17, color: isDark ? '#f1f5f9' : '#0f172a' }}>
                    {comment.lead?.name || 'N/A'}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, mt: 0.5, flexWrap: 'wrap' }}>
                    {comment.lead?.phone && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <PhoneIcon sx={{ fontSize: 13, color: '#1d4ed8' }} />
                        <Typography sx={{ fontSize: 12, color: txtSec }}>{comment.lead.phone}</Typography>
                      </Box>
                    )}
                    {comment.lead?.email && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <EmailIcon sx={{ fontSize: 13, color: '#1d4ed8' }} />
                        <Typography sx={{ fontSize: 12, color: txtSec }}>{comment.lead.email}</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Comment Details */}
            <Box sx={{ p: 2, borderRadius: 2, background: secBg, border: `1px solid ${border}` }}>
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#1d4ed8', mb: 1.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                💬 Comment Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: 11, color: txtSec, mb: 0.5 }}>Stage</Typography>
                  <StageTag chipcolor={getStageColor(comment.stage?.name)}>{comment.stage?.name || 'N/A'}</StageTag>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: 11, color: txtSec, mb: 0.5 }}>Developer</Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: 14, color: isDark ? '#f1f5f9' : '#0f172a' }}>
                    {comment.salesdeveloperName || 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: 11, color: txtSec, mb: 0.5 }}>Created At</Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 500, color: isDark ? '#f1f5f9' : '#0f172a' }}>
                    {comment.createdAt ? moment(comment.createdAt).format('DD MMM YYYY · hh:mm A') : 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontSize: 11, color: txtSec, mb: 0.5 }}>Stage Date</Typography>
                  <Typography sx={{ fontSize: 13, fontWeight: 500, color: isDark ? '#f1f5f9' : '#0f172a' }}>
                    {comment.stageDate ? moment(comment.stageDate).format('DD MMM YYYY · hh:mm A') : 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: 11, color: txtSec, mb: 0.5 }}>Comment</Typography>
                  <Box sx={{ p: 1.5, borderRadius: 1.5, background: isDark ? 'rgba(255,255,255,0.05)' : '#ffffff', border: `1px solid ${border}` }}>
                    <Typography sx={{ fontSize: 13, fontStyle: 'italic', color: isDark ? '#cbd5e1' : '#334155' }}>
                      {comment.comment || 'N/A'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {/* Replies */}
            {comment.replies?.length > 0 && (
              <Box sx={{ p: 2, borderRadius: 2, background: secBg, border: `1px solid ${border}` }}>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#1d4ed8', mb: 1.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  💬 Replies ({comment.replies.length})
                </Typography>
                {comment.replies.map((reply, idx) => (
                  <React.Fragment key={idx}>
                    <Box sx={{ display: 'flex', gap: 1.5, py: 1 }}>
                      <Avatar sx={{ width: 30, height: 30, background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)', fontSize: 11, fontWeight: 700 }}>
                        {reply.user?.name?.charAt(0) || '?'}
                      </Avatar>
                      <Box>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'baseline' }}>
                          <Typography sx={{ fontSize: 13, fontWeight: 700, color: isDark ? '#f1f5f9' : '#0f172a' }}>
                            {reply.user?.name || 'Unknown'}
                          </Typography>
                          <Typography sx={{ fontSize: 11, color: txtSec }}>
                            {reply.date ? moment(reply.date).format('DD MMM YYYY · hh:mm A') : ''}
                          </Typography>
                        </Box>
                        <Typography sx={{ fontSize: 13, color: txtSec, mt: 0.25 }}>{reply.text}</Typography>
                      </Box>
                    </Box>
                    {idx < comment.replies.length - 1 && <Divider sx={{ borderColor: border }} />}
                  </React.Fragment>
                ))}
              </Box>
            )}
          </Box>

          {/* Footer */}
          <Box sx={{ p: 2.5, borderTop: `1px solid ${border}`, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={onClose}
              variant="contained"
              sx={{
                borderRadius: 2, px: 3, textTransform: 'none', fontWeight: 700,
                background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
                '&:hover': { background: 'linear-gradient(135deg, #1e3a8a, #2563eb)' },
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Fade>,
    document.body,
  );
};

// ══════════════════════════════════════════════════════════════
//  Main Component
// ══════════════════════════════════════════════════════════════

export const PrivateSheetForUser = ({ open, onClose, userlogin }) => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  const [comments,        setComments]        = useState([]);
  const [loading,         setLoading]         = useState(false);
  const [page,            setPage]            = useState(1);
  const [rowsPerPage,     setRowsPerPage]     = useState(10);
  const [totalCount,      setTotalCount]      = useState(0);
  const [totalPages,      setTotalPages]      = useState(1);
  const [hasNextPage,     setHasNextPage]     = useState(false);
  const [hasPrevPage,     setHasPrevPage]     = useState(false);
  const [filterOpen,      setFilterOpen]      = useState(true);
  const [viewMode,        setViewMode]        = useState('table');
  const [selectedComment, setSelectedComment] = useState(null);
  const [detailsOpen,     setDetailsOpen]     = useState(false);
  const [allStages,       setAllStages]       = useState([]);

  const rescomments = useSelector((s) => s.AllMeetingComments?.MeetingComments);
  const All_stages  = useSelector((s) => s.Allstages?.stage);

  const getStageColor = (name) => {
    if (!name) return '#6b7280';
    const n = name.toLowerCase();
    if (n.includes('meeting')) return '#f97316';
    if (n.includes('eoi'))     return '#1d4ed8';
    if (n.includes('done'))    return '#16a34a';
    return '#6b7280';
  };

  const emptyFilters = {
    stage: '', searchTerm: '', createdFrom: '', createdTo: '',
    stageDateFrom: '', stageDateTo: '', sortOrder: 'desc',
  };
  const [filters,     setFilters]     = useState({ ...emptyFilters });
  const [tempFilters, setTempFilters] = useState({ ...emptyFilters });

  const activeFilterCount = Object.values(filters).filter((v) => v && v.toString().trim() !== '' && v !== 'desc').length;

  // ── Process stages ──
  useEffect(() => {
    if (All_stages?.data) {
      setAllStages(All_stages.data.filter((s) => ['Meeting', 'EOI', 'Done Deal'].includes(s.name)));
    } else if (Array.isArray(All_stages)) {
      setAllStages(All_stages.filter((s) => ['Meeting', 'EOI', 'Done Deal'].includes(s.name)));
    }
  }, [All_stages]);

  // ── Process redux comments ──
  useEffect(() => {
    if (!rescomments || !open) return;
    let commentsData = [], paginationData = {};

    if (rescomments?.data?.data && Array.isArray(rescomments.data.data)) {
      commentsData   = rescomments.data.data;
      paginationData = rescomments.data.pagination || {};
    } else if (rescomments?.data && Array.isArray(rescomments.data)) {
      commentsData   = rescomments.data;
      paginationData = rescomments.pagination || {};
    } else if (Array.isArray(rescomments)) {
      commentsData = rescomments;
    } else if (rescomments?.payload?.data) {
      commentsData   = rescomments.payload.data;
      paginationData = rescomments.payload.pagination || {};
    }

    setComments(commentsData);
    const total          = paginationData.totalResults || paginationData.total || commentsData.length || 0;
    const totalPagesCalc = paginationData.totalPages || Math.ceil(total / rowsPerPage) || 1;
    setTotalCount(total);
    setTotalPages(totalPagesCalc);
    setHasNextPage(paginationData.hasNextPage || page < totalPagesCalc);
    setHasPrevPage(paginationData.hasPrevPage || page > 1);
    if (paginationData.page) setPage(paginationData.page);
    setLoading(false);
  }, [rescomments, open, rowsPerPage, page]);

  // ── Reset & load on open ──
  useEffect(() => {
    if (open) {
      setFilters({ ...emptyFilters });
      setTempFilters({ ...emptyFilters });
      setPage(1);
      dispatch(GetAll_stage_Data()).catch(console.error);
      if (userlogin?.data?._id) loadComments(1, emptyFilters);
    }
  }, [open]); // eslint-disable-line

  const loadComments = useCallback(
    async (pageNum = page, filtersToUse = filters, customLimit = rowsPerPage) => {
      if (!userlogin?.data?._id) { Notify('error', 'User ID not found', 'error'); return; }
      setLoading(true);
      try {
        const q = new URLSearchParams();
        q.append('page',  pageNum);
        q.append('limit', customLimit);

        if (filtersToUse.stage) {
          const found = allStages.find((s) => s._id === filtersToUse.stage);
          if (found) q.append('stage', found._id);
        }
        if (filtersToUse.searchTerm) {
          const c = filtersToUse.searchTerm.replace(/[+\-\\()]/g, '');
          q.append('searchTerm', c);
        }
        if (filtersToUse.createdFrom)  q.append('createdFrom',  filtersToUse.createdFrom);
        if (filtersToUse.createdTo)    q.append('createdTo',    filtersToUse.createdTo);
        if (filtersToUse.stageDateFrom)q.append('stageDateFrom',filtersToUse.stageDateFrom);
        if (filtersToUse.stageDateTo)  q.append('stageDateTo',  filtersToUse.stageDateTo);
        q.append('sort', filtersToUse.sortOrder === 'asc' ? 'createdAt' : '-createdAt');

        await dispatch(Get_AllComments_For_Sheet_By_User_Action(`${userlogin.data._id}?${q.toString()}`));
      } catch (err) {
        console.error(err);
        Notify('error', 'Failed to load comments', 'error');
        setLoading(false);
      }
    },
    [dispatch, allStages, userlogin], // eslint-disable-line
  );

  const handleFilterChange    = (f, v) => setTempFilters((p) => ({ ...p, [f]: v }));
  const handleApplyFilters    = () => {
    const clean = { ...tempFilters };
    setFilters(clean); setPage(1); loadComments(1, clean);
  };
  const clearFilters          = () => {
    setTempFilters({ ...emptyFilters });
    setFilters({ ...emptyFilters });
    setPage(1);
    loadComments(1, emptyFilters);
  };
  const handlePageChange      = (n) => { setPage(n); loadComments(n, filters); };
  const handleRowsPerPageChange = (e) => {
    const n = parseInt(e.target.value, 10);
    setRowsPerPage(n); setPage(1); loadComments(1, filters, n);
  };

  const exportToExcel = () => {
    if (!comments.length) { Notify('warning', 'No data', 'warning'); return; }
    try {
      const ws = XLSX.utils.json_to_sheet(comments.map((c) => ({
        Date:        c.createdAt  ? moment(c.createdAt).format('DD/MM/YYYY HH:mm')  : 'N/A',
        'Lead Name': c.lead?.name  || 'N/A',
        'Lead Phone':c.lead?.phone || 'N/A',
        'Lead Email':c.lead?.email || 'N/A',
        Stage:       c.stage?.name || 'N/A',
        Comment:     c.comment     || 'N/A',
        Developer:   c.salesdeveloperName || 'N/A',
        'Stage Date':c.stageDate ? moment(c.stageDate).format('DD/MM/YYYY HH:mm') : 'N/A',
      })));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'My Comments');
      XLSX.writeFile(wb, `my_comments_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success', `Exported ${comments.length} rows`, 'success');
    } catch {
      Notify('error', 'Export failed', 'error');
    }
  };

  const getPageNumbers = () => {
    const delta = 2, range = [], out = []; let l;
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - delta && i <= page + delta)) range.push(i);
    }
    range.forEach((i) => {
      if (l) { if (i - l === 2) out.push(l + 1); else if (i - l !== 1) out.push('...'); }
      out.push(i); l = i;
    });
    return out;
  };

  const stageSummary = useMemo(() => {
    const map = {};
    comments.forEach((c) => { const n = c.stage?.name; if (n) map[n] = (map[n] || 0) + 1; });
    return Object.entries(map);
  }, [comments]);

  const menuProps = {
    sx: { zIndex: 60000 },
    PaperProps: { sx: { zIndex: 60000, borderRadius: 2, mt: 0.5 } },
  };

  const inputSx = (isDk) => ({
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px', fontSize: 13,
      backgroundColor: isDk ? '#0f1117' : '#ffffff',
      '& fieldset': { borderColor: isDk ? '#2a2f45' : '#e2e8f0' },
      '&:hover fieldset': { borderColor: '#1d4ed8' },
      '&.Mui-focused fieldset': { borderColor: '#1d4ed8', borderWidth: 2 },
    },
  });

  const selectSx = (isDk) => ({
    borderRadius: '8px', fontSize: 13,
    backgroundColor: isDk ? '#0f1117' : '#ffffff',
    '& .MuiOutlinedInput-notchedOutline': { borderColor: isDk ? '#2a2f45' : '#e2e8f0' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1d4ed8' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1d4ed8' },
  });

  const bg     = isDark ? '#0d0f1a' : '#f0f2f7';
  const cardBg = isDark ? '#1a1d2e' : '#ffffff';
  const border = isDark ? '#2a2f45' : '#e2e8f0';
  const txtPri = isDark ? '#f1f5f9' : '#0f172a';
  const txtSec = isDark ? '#94a3b8' : '#64748b';

  // ── Render ────────────────────────────────────────────────────
  return (
    <>
      {/* Backdrop */}
      <Fade in={open}>
        <Box
          onClick={onClose}
          sx={{
            position: 'fixed', inset: 0, zIndex: 49998,
            background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(3px)',
          }}
        />
      </Fade>

      {/* Panel */}
      <Box sx={{
        position: 'fixed', top: '50px',
        left: open ? sidebarWidth : '100vw',
        right: 0, bottom: 0,
        zIndex: 49999,
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
        background: bg,
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
        transition: 'left 0.35s cubic-bezier(0.4,0,0.2,1)',
      }}>

        {/* ── Header ── */}
        <PanelHeader>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative', zIndex: 1 }}>
            <Box sx={{
              width: 46, height: 46, borderRadius: 3,
              background: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              backdropFilter: 'blur(8px)',
            }}>
              <AssessmentIcon sx={{ fontSize: 22, color: '#fff' }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#fff', letterSpacing: -0.4, lineHeight: 1.2 }}>
                My Private Sheet
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.4 }}>
                <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.65)' }}>
                  {totalCount} total comments
                </Typography>
                {activeFilterCount > 0 && (
                  <Box sx={{ px: 1, py: 0.2, borderRadius: 10, background: 'rgba(255,255,255,0.15)', fontSize: 11, color: '#fff', fontWeight: 600 }}>
                    {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''} active
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, position: 'relative', zIndex: 1 }}>
            {/* View Toggle */}
            <Box sx={{ display: 'flex', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 1.5, overflow: 'hidden', mr: 0.5 }}>
              {[{ id: 'table', Icon: TableChartIcon }, { id: 'grid', Icon: GridViewIcon }].map(({ id, Icon }) => (
                <IconButton key={id} size="small" onClick={() => setViewMode(id)} sx={{
                  borderRadius: 0, px: 1.5,
                  bgcolor: viewMode === id ? 'rgba(255,255,255,0.2)' : 'transparent',
                  color: '#fff',
                }}>
                  <Icon sx={{ fontSize: 16 }} />
                </IconButton>
              ))}
            </Box>

            <Button
              startIcon={<DownloadIcon sx={{ fontSize: 16 }} />}
              onClick={exportToExcel}
              disabled={!comments.length}
              sx={{
                borderRadius: 2, textTransform: 'none', fontWeight: 600, fontSize: 13, px: 2,
                background: 'rgba(255,255,255,0.12)', color: '#fff',
                border: '1px solid rgba(255,255,255,0.2)', backdropFilter: 'blur(8px)',
                '&:hover': { background: 'rgba(255,255,255,0.2)' },
                '&.Mui-disabled': { color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.1)' },
              }}
            >
              Export
            </Button>
            <NavBtn
              onClick={() => loadComments(page, filters)}
              disabled={loading}
              sx={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.18)', color: '#fff', '&:hover': { background: 'rgba(255,255,255,0.22)' } }}
            >
              <RefreshIcon sx={{ fontSize: 16 }} />
            </NavBtn>
            <NavBtn
              onClick={onClose}
              sx={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.18)', color: '#fff', '&:hover': { background: 'rgba(220,38,38,0.5)', borderColor: 'transparent' } }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </NavBtn>
          </Box>
        </PanelHeader>

        {/* ── Body ── */}
        <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', p: '20px 24px', display: 'flex', flexDirection: 'column', gap: 2 }}>

          {/* ── Stats ── */}
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={4}>
              <StatCard>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(29,78,216,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <TableChartIcon sx={{ fontSize: 20, color: '#1d4ed8' }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, textTransform: 'uppercase', letterSpacing: 0.5 }}>Total Comments</Typography>
                  <Typography sx={{ fontSize: 22, fontWeight: 800, color: txtPri, lineHeight: 1.2 }}>{totalCount}</Typography>
                </Box>
              </StatCard>
            </Grid>
            <Grid item xs={12} sm={4}>
              <StatCard>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(22,163,74,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <PeopleAltIcon sx={{ fontSize: 20, color: '#16a34a' }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, textTransform: 'uppercase', letterSpacing: 0.5 }}>Unique Leads</Typography>
                  <Typography sx={{ fontSize: 22, fontWeight: 800, color: txtPri, lineHeight: 1.2 }}>
                    {new Set(comments.map((c) => c.lead?._id).filter(Boolean)).size}
                  </Typography>
                </Box>
              </StatCard>
            </Grid>
            <Grid item xs={12} sm={4}>
              <StatCard>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, background: 'rgba(249,115,22,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <AssessmentIcon sx={{ fontSize: 20, color: '#f97316' }} />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>By Stage</Typography>
                  <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
                    {stageSummary.length
                      ? stageSummary.map(([n, cnt]) => <StageTag key={n} chipcolor={getStageColor(n)}>{n} · {cnt}</StageTag>)
                      : <Typography sx={{ fontSize: 12, color: txtSec }}>—</Typography>}
                  </Box>
                </Box>
              </StatCard>
            </Grid>
          </Grid>

          {/* ── Filters ── */}
          <FilterPanel>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: filterOpen ? 2 : 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ width: 28, height: 28, borderRadius: 1.5, background: 'rgba(29,78,216,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FilterListIcon sx={{ fontSize: 15, color: '#1d4ed8' }} />
                </Box>
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: txtPri }}>Filters</Typography>
                {activeFilterCount > 0 && (
                  <Box sx={{ px: 1, py: 0.2, borderRadius: 10, background: '#1d4ed8', fontSize: 11, color: '#fff', fontWeight: 700 }}>
                    {activeFilterCount}
                  </Box>
                )}
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {activeFilterCount > 0 && (
                  <Button onClick={clearFilters} size="small" sx={{ textTransform: 'none', fontSize: 12, color: '#ef4444', borderRadius: 1.5, px: 1.5, minWidth: 0, '&:hover': { background: 'rgba(239,68,68,0.08)' } }}>
                    Clear all
                  </Button>
                )}
                <Button onClick={() => setFilterOpen(!filterOpen)} size="small" sx={{ textTransform: 'none', fontSize: 12, color: txtSec, borderRadius: 1.5, px: 1.5, minWidth: 0 }}>
                  {filterOpen ? 'Hide' : 'Show'}
                </Button>
              </Box>
            </Box>

            {filterOpen && (
              <>
                {/* Row 1 */}
                <Grid container spacing={1.5} alignItems="flex-end">
                  {/* Search */}
                  <Grid item xs={12} md={3}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Lead Name / Phone
                    </Typography>
                    <TextField
                      fullWidth size="small" placeholder="Search..."
                      value={tempFilters.searchTerm}
                      onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ fontSize: 15, color: '#94a3b8' }} />
                          </InputAdornment>
                        ),
                        endAdornment: tempFilters.searchTerm && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => handleFilterChange('searchTerm', '')}>
                              <ClearIcon sx={{ fontSize: 13 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                        sx: { borderRadius: '8px', fontSize: 13 },
                      }}
                      sx={inputSx(isDark)}
                    />
                  </Grid>

                  {/* Stage */}
                  <Grid item xs={12} md={2}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Stage
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={tempFilters.stage || ''}
                        onChange={(e) => handleFilterChange('stage', e.target.value)}
                        displayEmpty
                        sx={{ ...selectSx(isDark) }}
                        MenuProps={menuProps}
                      >
                        <MenuItem value=""><em style={{ fontStyle: 'normal' }}>All Stages</em></MenuItem>
                        {allStages.map((s) => (
                          <MenuItem key={s._id} value={s._id} sx={{ fontSize: 13 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: getStageColor(s.name), flexShrink: 0 }} />
                              {s.name}
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Sort */}
                  <Grid item xs={12} md={2}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Sort By
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={tempFilters.sortOrder}
                        onChange={(e) => handleFilterChange('sortOrder', e.target.value)}
                        displayEmpty
                        sx={{ ...selectSx(isDark) }}
                        MenuProps={menuProps}
                      >
                        <MenuItem value="desc" sx={{ fontSize: 13 }}>Newest First</MenuItem>
                        <MenuItem value="asc"  sx={{ fontSize: 13 }}>Oldest First</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Created From */}
                  <Grid item xs={6} md={1.5}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      From
                    </Typography>
                    <TextField
                      fullWidth size="small" type="date"
                      value={tempFilters.createdFrom}
                      onChange={(e) => handleFilterChange('createdFrom', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={inputSx(isDark)}
                      InputProps={{ sx: { borderRadius: '8px', fontSize: 12 } }}
                    />
                  </Grid>

                  {/* Created To */}
                  <Grid item xs={6} md={1.5}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      To
                    </Typography>
                    <TextField
                      fullWidth size="small" type="date"
                      value={tempFilters.createdTo}
                      onChange={(e) => handleFilterChange('createdTo', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={inputSx(isDark)}
                      InputProps={{ sx: { borderRadius: '8px', fontSize: 12 } }}
                    />
                  </Grid>

                  {/* Apply */}
                  <Grid item xs={12} md="auto">
                    <Button
                      variant="contained"
                      onClick={handleApplyFilters}
                      sx={{
                        borderRadius: 2, textTransform: 'none', fontWeight: 700, fontSize: 13, px: 3, height: 40,
                        background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
                        boxShadow: '0 2px 10px rgba(29,78,216,0.3)',
                        '&:hover': { background: 'linear-gradient(135deg, #1e3a8a, #2563eb)', boxShadow: '0 4px 16px rgba(29,78,216,0.4)' },
                      }}
                    >
                      Apply
                    </Button>
                  </Grid>
                </Grid>

                {/* Row 2 — Stage Date */}
                <Grid container spacing={1.5} alignItems="flex-end" sx={{ mt: 0.5 }}>
                  <Grid item xs={6} md={2}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Stage Date From
                    </Typography>
                    <TextField
                      fullWidth size="small" type="date"
                      value={tempFilters.stageDateFrom}
                      onChange={(e) => handleFilterChange('stageDateFrom', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={inputSx(isDark)}
                      InputProps={{ sx: { borderRadius: '8px', fontSize: 12 } }}
                    />
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: txtSec, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                      Stage Date To
                    </Typography>
                    <TextField
                      fullWidth size="small" type="date"
                      value={tempFilters.stageDateTo}
                      onChange={(e) => handleFilterChange('stageDateTo', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={inputSx(isDark)}
                      InputProps={{ sx: { borderRadius: '8px', fontSize: 12 } }}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </FilterPanel>

          {/* ── Table Card ── */}
          <Box sx={{ background: cardBg, borderRadius: 3, border: `1px solid ${border}`, overflow: 'hidden', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>

            {/* Table toolbar */}
            <Box sx={{ px: 2.5, py: 1.75, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${border}` }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 700, color: txtPri }}>Comments</Typography>
                <Box sx={{ px: 1.25, py: 0.25, borderRadius: 10, background: isDark ? 'rgba(29,78,216,0.15)' : '#eff6ff', color: '#1d4ed8', fontSize: 11, fontWeight: 700, letterSpacing: 0.4 }}>
                  {totalCount} results
                </Box>
              </Box>
              <Typography sx={{ fontSize: 12, color: txtSec }}>Page {page} of {totalPages}</Typography>
            </Box>

            {loading && (
              <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #1e3a8a, #1d4ed8)' } }} />
            )}

            {/* Empty state */}
            {!loading && !comments.length && (
              <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, gap: 1.5 }}>
                <Box sx={{ width: 64, height: 64, borderRadius: '50%', background: isDark ? 'rgba(255,255,255,0.04)' : '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CommentIcon sx={{ fontSize: 28, color: txtSec }} />
                </Box>
                <Typography sx={{ fontSize: 15, fontWeight: 600, color: txtPri }}>No comments found</Typography>
                <Typography sx={{ fontSize: 13, color: txtSec }}>Try adjusting your filters</Typography>
                <Button
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  onClick={() => loadComments(1, filters)}
                  sx={{ mt: 1, borderRadius: 2, textTransform: 'none', borderColor: '#1d4ed8', color: '#1d4ed8', '&:hover': { background: 'rgba(29,78,216,0.06)' } }}
                >
                  Refresh
                </Button>
              </Box>
            )}

            {/* ── Table View ── */}
            {!loading && !!comments.length && viewMode === 'table' && (
              <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
                <Table size="small" sx={{ tableLayout: 'fixed' }}>
                  <TableHead>
                    <TableRow sx={{ background: isDark ? 'rgba(255,255,255,0.02)' : '#f8fafc' }}>
                      {['DATE', 'LEAD', 'STAGE', 'COMMENT', 'DEVELOPER', 'ACTIONS'].map((h) => (
                        <TableCell key={h} sx={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.8, color: isDark ? '#475569' : '#94a3b8', textTransform: 'uppercase', borderBottom: `2px solid ${isDark ? 'rgba(255,255,255,0.06)' : '#e2e8f0'}`, py: 1.5, px: 2.5 }}>
                          {h}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {comments.map((c, i) => (
                      <TableRow
                        key={c._id || i}
                        onClick={() => { setSelectedComment(c); setDetailsOpen(true); }}
                        sx={{
                          cursor: 'pointer',
                          borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.04)' : '#f1f5f9'}`,
                          '&:hover': { background: isDark ? 'rgba(29,78,216,0.07)' : 'rgba(29,78,216,0.03)' },
                          transition: 'background 0.12s ease',
                        }}
                      >
                        {/* Date */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <Typography sx={{ fontSize: 13, fontWeight: 700, color: txtPri }}>
                            {c.createdAt ? moment(c.createdAt).format('DD MMM YYYY') : '—'}
                          </Typography>
                          <Typography sx={{ fontSize: 11, color: txtSec, mt: 0.2 }}>
                            {c.createdAt ? moment(c.createdAt).format('hh:mm A') : ''}
                          </Typography>
                        </TableCell>

                        {/* Lead */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Avatar sx={{ width: 34, height: 34, fontSize: 13, fontWeight: 800, background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)', flexShrink: 0 }}>
                              {c.lead?.name?.charAt(0)?.toUpperCase() || '?'}
                            </Avatar>
                            <Box>
                              <Typography sx={{ fontSize: 13, fontWeight: 700, color: txtPri }}>{c.lead?.name || 'N/A'}</Typography>
                              {c.lead?.phone && <Typography sx={{ fontSize: 11, color: txtSec }}>{c.lead.phone}</Typography>}
                            </Box>
                          </Box>
                        </TableCell>

                        {/* Stage */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <StageTag chipcolor={getStageColor(c.stage?.name)}>{c.stage?.name || 'N/A'}</StageTag>
                          {c.stageDate && (
                            <Typography sx={{ fontSize: 11, color: txtSec, mt: 0.5 }}>
                              {moment(c.stageDate).format('DD MMM YYYY')}
                            </Typography>
                          )}
                        </TableCell>

                        {/* Comment */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          <Tooltip
                            title={c.comment || ''}
                            arrow placement="top"
                            componentsProps={{ tooltip: { sx: { maxWidth: 320, fontSize: 12, borderRadius: 2 } } }}
                          >
                            <Typography sx={{ fontSize: 13, color: txtSec, fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 240, cursor: 'help' }}>
                              {c.comment ? `"${c.comment}"` : '—'}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        {/* Developer */}
                        <TableCell sx={{ px: 2.5, py: 2 }}>
                          {c.salesdeveloperName
                            ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Avatar sx={{ width: 26, height: 26, fontSize: 11, fontWeight: 700, bgcolor: '#7c3aed' }}>
                                  {c.salesdeveloperName.charAt(0)}
                                </Avatar>
                                <Typography sx={{ fontSize: 13, fontWeight: 500, color: txtPri }}>{c.salesdeveloperName}</Typography>
                              </Box>
                            )
                            : <Typography sx={{ fontSize: 13, color: txtSec }}>—</Typography>}
                        </TableCell>

                        {/* Actions */}
                        <TableCell sx={{ px: 2.5, py: 2 }} onClick={(e) => e.stopPropagation()}>
                          <NavBtn
                            onClick={(e) => { e.stopPropagation(); setSelectedComment(c); setDetailsOpen(true); }}
                            sx={{ width: 28, height: 28 }}
                          >
                            <OpenInNewIcon sx={{ fontSize: 13 }} />
                          </NavBtn>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {/* ── Grid View ── */}
            {!loading && !!comments.length && viewMode === 'grid' && (
              <Box sx={{ p: 2, overflowY: 'auto', flex: 1 }}>
                <Grid container spacing={2}>
                  {comments.map((c, i) => (
                    <Grid item xs={12} sm={6} md={4} key={c._id || i}>
                      <Box
                        onClick={() => { setSelectedComment(c); setDetailsOpen(true); }}
                        sx={{
                          p: 2, borderRadius: 2, cursor: 'pointer',
                          border: `1px solid ${border}`,
                          background: isDark ? '#1a1d2e' : '#ffffff',
                          transition: 'all 0.15s ease',
                          '&:hover': { borderColor: '#1d4ed8', transform: 'translateY(-2px)', boxShadow: '0 8px 24px rgba(29,78,216,0.12)' },
                        }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                          <StageTag chipcolor={getStageColor(c.stage?.name)}>{c.stage?.name || 'N/A'}</StageTag>
                          <Typography sx={{ fontSize: 11, color: txtSec }}>{c.createdAt ? moment(c.createdAt).format('DD MMM YYYY') : ''}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                          <Avatar sx={{ width: 38, height: 38, background: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)', fontSize: 14, fontWeight: 800 }}>
                            {c.lead?.name?.charAt(0)?.toUpperCase() || '?'}
                          </Avatar>
                          <Box>
                            <Typography sx={{ fontSize: 13, fontWeight: 700, color: txtPri }}>{c.lead?.name || 'N/A'}</Typography>
                            <Typography sx={{ fontSize: 11, color: txtSec }}>{c.lead?.phone || ''}</Typography>
                          </Box>
                        </Box>
                        <Typography sx={{ fontSize: 12, color: txtSec, fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', mb: 1.5 }}>
                          "{c.comment || 'N/A'}"
                        </Typography>
                        <Divider sx={{ mb: 1.5, borderColor: border }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Avatar sx={{ width: 22, height: 22, fontSize: 10, bgcolor: '#7c3aed' }}>
                            {c.salesdeveloperName?.charAt(0) || '?'}
                          </Avatar>
                          <Typography sx={{ fontSize: 12, color: txtSec }}>{c.salesdeveloperName || 'N/A'}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}

            {/* ── Pagination ── */}
            {!loading && !!comments.length && (
              <Box sx={{
                px: 2.5, py: 1.5,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                flexWrap: 'wrap', gap: 2,
                borderTop: `1px solid ${border}`,
                background: isDark ? 'rgba(255,255,255,0.02)' : '#fafbfd',
              }}>
                <Typography sx={{ fontSize: 12, color: txtSec }}>
                  Showing{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: txtPri }}>
                    {Math.min((page - 1) * rowsPerPage + 1, totalCount)}–{Math.min(page * rowsPerPage, totalCount)}
                  </Box>
                  {' '}of{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: txtPri }}>{totalCount}</Box>
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <NavBtn onClick={() => handlePageChange(1)}          disabled={page === 1}>        <FirstPageIcon sx={{ fontSize: 13 }} /></NavBtn>
                  <NavBtn onClick={() => handlePageChange(page - 1)}   disabled={!hasPrevPage}>      <KeyboardArrowLeftIcon sx={{ fontSize: 15 }} /></NavBtn>
                  {getPageNumbers().map((n, idx) =>
                    n === '...'
                      ? <Typography key={`d${idx}`} sx={{ px: 0.5, fontSize: 13, color: txtSec }}>···</Typography>
                      : <PgBtn key={n} isactive={String(page === n)} onClick={() => handlePageChange(n)}>{n}</PgBtn>
                  )}
                  <NavBtn onClick={() => handlePageChange(page + 1)}   disabled={!hasNextPage}>      <KeyboardArrowRightIcon sx={{ fontSize: 15 }} /></NavBtn>
                  <NavBtn onClick={() => handlePageChange(totalPages)} disabled={page === totalPages}><LastPageIcon sx={{ fontSize: 13 }} /></NavBtn>
                </Box>

                <FormControl size="small" sx={{ minWidth: 110 }}>
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    displayEmpty
                    sx={{ borderRadius: 2, fontSize: 12, height: 32, ...selectSx(isDark) }}
                    MenuProps={menuProps}
                  >
                    {[10, 25, 50, 100].map((n) => (
                      <MenuItem key={n} value={n} sx={{ fontSize: 13 }}>{n} / page</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      {/* ── Details Modal ── */}
      <DetailsModal
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        comment={selectedComment}
        isDark={isDark}
        getStageColor={getStageColor}
      />
    </>
  );
};